module.exports = __webpack_public_path__ + "resource/img/intro_bg.jpg?ef61fbf3224a36d388aac6d954dcb838";


//////////////////
// WEBPACK FOOTER
// ./src/images/intro_bg.jpg
// module id = 444
// module chunks = 36